import heading from './heading';
import title from './title';
import footer from './footer';

export default { ...heading, title, footer };
